import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { App } from './App';
import { identifyOpenPanel, syncOpenPanelEnabled } from './helpers/openPanelHelper';
import { identifyCustomerIo, syncCustomerIoEnabled } from './helpers/customerIoHelper';
import { getUser } from './services/authService';
import { SystemSettingsService } from './services/systemSettingsService';

// Enable analytics before the first render (so no screen-mount event races the
// SDK) using the cached system settings from a previous session — sends only
// happen when the backend `openPanelEnabled` flag is true. App.js re-syncs
// from the fresh GetForFront response. Identity re-attaches for
// already-authenticated sessions.
const cachedSettings = new SystemSettingsService().systemSettings();
syncOpenPanelEnabled(cachedSettings);
identifyOpenPanel(getUser());
syncCustomerIoEnabled(cachedSettings);
identifyCustomerIo(getUser());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<I18nextProvider i18n={i18next}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
